import { useState, useCallback } from 'react'
import { FormSubmission } from '@/core/models/form.model'

type DialogType = 'detail' | 'respond' | null

export function useEthicsDialogs() {
  const [activeDialog, setActiveDialog] = useState<DialogType>(null)
  const [selectedSubmission, setSelectedSubmission] = useState<FormSubmission | null>(null)

  const openDetail = useCallback((submission: FormSubmission) => {
    setSelectedSubmission(submission)
    setActiveDialog('detail')
  }, [])

  const openRespond = useCallback(() => {
    setActiveDialog('respond')
  }, [])

  const closeDialog = useCallback(() => {
    setActiveDialog(null)
    setSelectedSubmission(null)
  }, [])

  const switchToRespond = useCallback(() => {
    setActiveDialog('respond')
  }, [])

  return {
    activeDialog,
    selectedSubmission,
    openDetail,
    openRespond,
    closeDialog,
    switchToRespond,
  }
}
